import { FetchOptions } from '@atlaskit/web-config-client';

import { STATSIG_KEYS } from '@/constants';

export const getDynamicConfigOptions = (orgId: string): FetchOptions => {
  const env = __DEPLOY_ENV__;
  let apiKey: string;
  let baseUrl: string;
  switch (env) {
    case 'production':
      apiKey = STATSIG_KEYS.production;
      baseUrl = 'https://api.atlassian.com/flags';
      break;
    case 'staging':
      apiKey = STATSIG_KEYS.staging;
      baseUrl = 'https://api.stg.atlassian.com/flags';
      break;
    default:
      apiKey = STATSIG_KEYS.development;
      baseUrl = 'https://api.dev.atlassian.com/flags';
  }

  const options = {
    // Base URL of the feature-flag-service
    ffsBaseUrl: baseUrl,
    // Your feature-flag-service API key, you can get it from:
    // https://developer.atlassian.com/platform/frontend-feature-flags/resources/api-keys/
    ffsApiKey: apiKey,
    // User context to evaluate the configuration against
    context: {
      namespace: 'slo-ui_web',
      identifiers: {
        // This is required, but since we are not suppose to pass any user
        // specific info, we can just set it to an undefined value
        atlassianAccountId: 'undefined',
      },
      metadata: {
        atlassianOrgId: orgId,
      },
    },
  };
  return options;
};

// Feature flags should be prefixed with `slo_ui_`
export enum FeatureFlags {
  // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/slo_ui_allow_mimir_slos
  AllowMimirSLO = 'slo_ui_allow_mimir_slos',
  // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/slo_ui_allow_simulation
  AllowSimulation = 'slo_ui_allow_simulation',
}
